import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { OnyxEvent } from '../models/event';
import { PartyType } from '../models/party-type';

@Component({
  selector: 'pioneer-child-contact-form',
  templateUrl: './child-contact-form.component.html'
})
export class ChildContactFormComponent implements OnInit, OnChanges {

  @Input('partyType')
  public partyType: PartyType;

  @Input('contactReferenceNumberTitle')
  public contactReferenceNumberTitle: String;

  @Input('contactForm')
  public contactForm: FormGroup;

  public onyxEvent: OnyxEvent;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input()
  public isReadOnly = true;

  @Input()
  public showLongLabels = false;

  @Input()
  public showSubscriberBadge = false;

  @Input()
  public clientContactEditable = true;

  @Input()
  public inputEmail: string;

  @Output()
  public outputEmail: EventEmitter<string> = new EventEmitter<string>();

  constructor(private environment: EnvironmentConfiguration) {
  }

  public ngOnInit() {

    if (this.emailValidation()) {
      this.contactForm.get('contact').get('email').valueChanges.subscribe(value => {
        this.outputEmail.emit(value);

        this.checkDuplicatedEmailError(value);
      });
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.emailValidation() && changes.inputEmail && this.contactForm) {
      this.checkDuplicatedEmailError(this.contactForm.get('contact').get('email').value);
    }

    if (!changes[ 'event' ]) {
      return;
    }
  }

  private checkDuplicatedEmailError(formValue) {
    if (formValue && formValue === this.inputEmail) {
      this.contactForm.get('contact').get('email').setErrors({'email_contact_property_agency_same': true});
    } else {
      if (this.contactForm && this.contactForm.get('contact').get('email').errors
          && this.contactForm.get('contact').get('email').errors['email_contact_property_agency_same']) {
        this.contactForm.get('contact').get('email').setErrors(null);
      }
    }
  }

  public emailValidation(): boolean {
    return this.environment.emailValidation;
  }

  public getReadOnly() {
    if (this.partyType === PartyType.CLIENT) {
      return this.isReadOnly || !this.clientContactEditable;
    } else {
      return this.isReadOnly;
    }
  }

  public getReadOnlyClient() {
    if (this.partyType === PartyType.CLIENT) {
      return this.isReadOnly || !this.clientContactEditable;
    } else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/child-contact-form/child-contact-form.component.ts